import { EventsWidget } from '@/components/EventsWidget';

export function EventsRoute() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Events</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Append-only log of state changes, alerts, and operator actions. Set
          <code className="mx-1 rounded bg-muted px-1.5 py-0.5 text-xs">
            ALERT_WEBHOOK_URL
          </code>
          in
          <code className="mx-1 rounded bg-muted px-1.5 py-0.5 text-xs">
            /etc/home-dashboard/dashboard.env
          </code>
          to fire these to a webhook (Discord / n8n / etc).
        </p>
      </div>
      <EventsWidget limit={200} />
    </div>
  );
}
